/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type { IMGear, IMGearInterface } from "../IMGear";

const _abi = [
  {
    inputs: [
      {
        internalType: "uint256",
        name: "mgear",
        type: "uint256",
      },
    ],
    name: "renderData",
    outputs: [
      {
        internalType: "string",
        name: "svg",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

export class IMGear__factory {
  static readonly abi = _abi;
  static createInterface(): IMGearInterface {
    return new utils.Interface(_abi) as IMGearInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): IMGear {
    return new Contract(address, _abi, signerOrProvider) as IMGear;
  }
}
